/**
 * Shared presentation helper for the portfolio -> evaluation sync.
 *
 * Lives here rather than beside either caller because both the Evaluations
 * Sites tab and the Portfolios detail page report the same result, and the
 * Sites tab pulls in MapLibre — importing from it would drag the map bundle
 * onto the Portfolios route.
 */

export interface SyncCounts {
	added?: number
	removed?: number
	skipped?: number
}

/**
 * Turns a sync response into one line a user can act on.
 *
 * The all-zero case is deliberately special-cased: a re-sync with nothing to do
 * is the common outcome, and "Added 0 sites, removed 0" reads like a failure.
 */
export function formatSyncSummary({ added = 0, removed = 0, skipped = 0 }: SyncCounts = {}) {
	if (added === 0 && removed === 0) {
		return 'Already up to date with the portfolio.'
	}
	const parts: string[] = []
	if (added > 0) parts.push(`Added ${added} site${added === 1 ? '' : 's'}`)
	if (removed > 0) parts.push(`removed ${removed}`)
	if (skipped > 0) parts.push(`${skipped} already present`)
	return `${parts.join(', ')}.`
}
